import React, { useState } from 'react'

import { sidebarLinks } from '../../../data/dashboard-links'
import {logout} from "../../../services/operations/authAPI"
import { useDispatch, useSelector } from 'react-redux'
import SidebarLink from './SidebarLink'
import { useNavigate } from 'react-router-dom'
import {VscSignOut} from "react-icons/vsc"
import ConfirmationModal from '../../common/ConfirmationModal'
const Sidebar = () => {

    const {user, loading: profileLoading} = useSelector((state) => state.profile);
    const {loading:authLoading} = useSelector((state)=>state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [confirmationModal, setConfirmationModal] = useState(null);

    if(profileLoading || authLoading) {
        return (
            <div className="flex min-h-[120px] w-full shrink-0 items-center justify-center bg-richblack-800 py-6 text-sm text-richblack-200 lg:min-h-[calc(100vh-3.5rem)] lg:min-w-[222px] lg:py-0">
                Loading...
            </div>
        )
    }

  return (
    <div className="shrink-0 bg-richblack-800 text-richblack-5">
        <div
          className="hidden h-[calc(100vh-3.5rem)] min-w-[222px] flex-col border-r border-richblack-700 bg-richblack-800 py-10 lg:flex"
        >

            <div className='flex flex-col'>
                {
                    sidebarLinks.map((link) => {
                        if(link.type && user?.accountType !== link.type) return null;
                        return (
                            <SidebarLink key={link.id}  link={link} iconName={link.icon} />
                        )
                    })}
            </div>

            <div className='mx-auto mt-6 mb-6 h-[1px] w-10/12 bg-richblack-600'></div>

            <div className='flex flex-col'>
                    <SidebarLink
                        key="settings-desktop"
                        link={{ name: "Settings", path: "/dashboard/settings" }}
                        iconName="VscSettingsGear"
                    />

                    <button 
                        onClick={ () => setConfirmationModal({
                            text1: "Are You Sure ?",
                            text2: "You will be logged out of your Account",
                            btn1Text: "Logout",
                            btn2Text:"Cancel",
                            btn1Handler: () => dispatch(logout(navigate)),
                            btn2Handler: () => setConfirmationModal(null),
                        })}
                        className='text-sm font-medium text-richblack-300 mx-4 my-4'>

                        <div className='flex items-center gap-x-2 p-4'>
                            <VscSignOut className='text-lg'/>
                            <span>Logout</span>
                        </div>

                    </button>

            </div>

        </div>







        {/* mobile sidebar */}
        <div className="fixed bottom-0 z-50 flex w-full items-center justify-between border-t border-richblack-700 bg-richblack-900 px-1 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] lg:hidden">
        <div className="flex w-full flex-row justify-between gap-0.5">
                {
                    sidebarLinks.map((link) => {
                        if(link.type && user?.accountType !== link.type) return null;
                        return (
                            <SidebarLink key={link.id}  link={link} iconName={link.icon} />
                        )
                    })}
                    <SidebarLink
                        key="settings-mobile"
                        link={{ name: "Settings", path: "/dashboard/settings" }}
                        iconName="VscSettingsGear"
                    />
            </div>
            

        </div>



      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </div>
  )
}

export default Sidebar
